import { render, staticRenderFns } from "./abbreviation.vue?vue&type=template&id=568d0d58&scoped=true&"
import script from "./abbreviation.vue?vue&type=script&lang=js&"
export * from "./abbreviation.vue?vue&type=script&lang=js&"
import style0 from "./abbreviation.vue?vue&type=style&index=0&id=568d0d58&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d0d58",
  null
  
)

export default component.exports